import { patchApiGalaxyServer } from 'services';

export interface UpdateTeamApproverPayload {
  teamId: string;
  developerApprover?: string;
  supportApprover?: string;
  realmId: string;
  tenant: string;
}

export interface UpdateTeamApproverErrorResponse {
  message: string;
  error: string;
  statusCode: number;
}

export interface UpdateTeamApproverResponse {
  affected: number;
}

export const updateTeamApproverApi = ({
  params,
  token,
  config,
}: BaseApiParams<UpdateTeamApproverPayload>) => {
  return patchApiGalaxyServer('/lookup/teams/approver', params, config, token);
};
